import styled from "styled-components";
import { EmbedTheme } from "../../utils/embeds";
import { V3Body, V3Caption, V3HeadlineH3 } from "../Typography";
import { ClampMixin, ClampMixinType } from "../ReusableStyledComponents/ClampMixin";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";

export type EmbedWithClamp = { $embedTheme: EmbedTheme } & ClampMixinType;

const UserThemableCollBody = styled(V3Body)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedCollBody = styled(UserThemableCollBody) <EmbedWithClamp>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey48};
    ${ClampMixin};
`;

const UserThemableEmbedCollectionTitle = styled(V3HeadlineH3)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedCollectionTitle = styled(UserThemableEmbedCollectionTitle) <EmbedWithClamp>`
    color: ${({ $embedTheme }) => $embedTheme === EmbedTheme.dark ? "white" : undefined};
    font-size: 24px;
    line-height: 30px;
    ${ClampMixin};
`;

const UserThemableEmbedCollectionDesc = styled(V3Caption)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedCollectionDesc = styled(UserThemableEmbedCollectionDesc) <EmbedWithClamp>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey48};
    ${ClampMixin};;
`;

export const V3EmbedCollectionSeparator = styled.hr`
    background: ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    height: 1px;
    border: 0;
    margin: 0;
`;